<template>
  <section class="Contact" id="Contact">
    <div class="contact_wrapper">
      <div class="title light">
        <span>
          Contáctanos
        </span>
      </div>
      <div class="contact_form">
        <form>
          <div class="input_wrapper" :class="{ 'require': !validateDNI && trigger }">
            <label> DNI <strong>· dni no válido </strong> </label>
            <input v-model="contact.dni" ref="dni" type="text">
          </div>
          <div class="input_wrapper" :class="{ 'require': !validateNames && trigger }">
            <label> NOMBRES Y APELLIDOS <strong>· nombre muy corto </strong> </label>
            <input v-model="contact.names" type="text" placeholder="Ejem: Juan Perez">
          </div>
          <div class="input_wrapper" :class="{ 'require': !validatePhone && trigger }">
            <label> TELÉFONO / CELULAR <strong>· telefono no válido </strong> </label>
            <input v-model="contact.phone" type="text" placeholder="Ejem: 999 555 000">
          </div>
          <div class="input_wrapper" :class="{ 'require': !validateSubject && trigger }">
            <label> ASUNTO  <strong>· asunto muy corto </strong></label>
            <textarea v-model="contact.subject" placeholder="Motivo del mensaje" />
          </div>
          <button v-if="!loading" class="Button" :class="{ sended: sended }" @click.prevent="checkMessage()"> {{ !sended ? "Enviar Mensaje" : "Enviado 😉"  }} </button>
          <button v-else class="Button loading">
            <span class="spin"></span>
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { firestore } from '@/main'
export default {
  data: () => ({
    contact: {
      dni: "",
      names: "",
      phone: "",
      subject: ""
    },
    loading: false,
    sended: false,
    trigger: false
  }),
  mounted () {
    // window.addEventListener('scroll', () => {
    //   const contact = document.getElementById('Contact')
    //   let top = document.documentElement.scrollTop
    //   let height = document.documentElement.clientHeight
    //   if ( top + (height / 1.2) > contact.offsetTop + (contact.clientHeight / 2) ) {
    //     contact.classList.add('trigger')
    //     this.$nextTick(() => {
    //       this.$refs.dni.focus()
    //     })
    //   }
    // })
  },
  methods: {
    checkMessage () {
      this.trigger = true
      if ( this.validateDNI && this.validateNames && this.validatePhone && this.validateSubject ) {
        this.trigger = false
        this.sendMessage()
      }
    },
    sendMessage() {
      this.loading = true
      firestore.collection("contact").add(this.contact)
      .then((res) => {
        console.log('guardado', res)
        this.contact = {
          dni: "",
          names: "",
          phone: "",
          subject: ""
        }
        this.sended = true
        this.loading = false
        setTimeout(() => {
          this.sended = false
        }, 5000);
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
    }
  },
  computed: {
    validateDNI () {
      return this.contact.dni.length == 8
    },
    validateNames () {
      return this.contact.names.length > 3
    },
    validatePhone () {
      return this.contact.phone.length == 6 || this.contact.phone.length == 9
    },
    validateSubject () {
      return this.contact.subject.length > 3
    }
  }
}
</script>

<style lang="sass">
@import '../assets/css/app.sass'
.Contact
  width: 980px
  margin: 0 auto
  padding: 7rem 70px
  box-sizing: border-box
  .contact_wrapper
    display: grid
    grid-template-columns: 1fr 450px
    .title
      position: relative
      height: 30px
      span
        position: absolute
        left: 0
        top: 0
        transition: all ease-in-out .3s .5s
    .contact_form
      font-family: $font
      form
        display: flex
        flex-direction: column
        align-items: flex-end
        width: 100%
        .Button
          width: 200px
          &.sended
            background-color: $primary_color
            color: white
          .spin
            width: 16px
            height: 16px
            border-radius: 50%
            display: flex
            border: 2px solid $primary_color
            border-bottom: 2px solid rgba($primary_color, .2)
            border-left: 2px solid rgba($primary_color, .2)
            margin: 0 auto
            animation: spin .4s infinite ease-in-out
        .input_wrapper
          width: 100%
          display: flex
          flex-direction: column
          margin-bottom: 40px
          &.require
            &:before
              background-color: red
            label
              strong
                color: red
                display: inline-flex
            input
              border-bottom: 1px solid red
          &:before
            transform: scaleX(0)
            transition: transform ease-in-out .3s
            position: absolute
            transform-origin: left
            content: ''
            left: 0
            bottom: 0
            height: 3px
            width: 100%
            background-color: $primary_color
          &:focus-within
            position: relative
            label
              color: rgba($primary_color, 1)
            &:before
              transform: scaleX(1)
          label
            color: rgba($primary_color, .7)
            font-size: 11px
            font-weight: 500
            letter-spacing: 1px
            strong
              display: none
          input, textarea
            font-family: $font
            height: 40px
            border: 0
            border-bottom: 1px solid rgba($primary_color, .7)
            color: $primary_color
            font-size: 14px
            &::placeholder
              color: rgba($primary_color, .5)
          textarea
            height: 80px
            padding-top: 10px

@media screen and (max-width: 980px)
  .Contact
    width: 760px
    padding: 5rem 70px
    .contact_wrapper
      grid-template-columns: 1fr 350px

@media screen and (max-width: 760px)
  .Contact
    width: 480px
    padding: 5rem 0
    .contact_wrapper
      grid-template-columns: 1fr 270px

@media screen and (max-width: 560px)
  .Contact
    width: 320px
    .contact_wrapper
      grid-template-columns: 1fr
      grid-gap: 50px

@media screen and (max-width: 400px)
  .Contact
    width: 100%
    padding:
      left: 40px
      right: 40px
    box-sizing: border-box
    .contact_wrapper
      .contact_form
        form
          .Button
            width: 100%
</style>